// src/utils/formUtils.js
export const isQuestionValid = (question, formData) => {
  const value = formData[question.id];
  // console.log(question, formData, value);

  if (question.required) {
    // For range questions, allow 0 as a valid value.
    if (question.fieldType === "range") {
      return value !== undefined && value !== null && value !== "";
    } else {
      // For other types, check that the value is not undefined, null, or an empty string.
      return value !== undefined && value !== null && value !== "";
    }
  }
  return true;
};
